import { userConstants } from "../constants/login.constants";

 function businessNameReport(state = {}, action) {
    switch (action.type) {
        case userConstants.BUSINESSNAMEREPORT_REQUEST:
            return {
                loading: true
            };
        case userConstants.BUSINESSNAMEREPORT_SUCCESS:
            return {
                items: action.businessNameReport
            };
        case userConstants.BUSINESSNAMEREPORT_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default businessNameReport;